import FFBaseController from 'FF/Controllers/Base/BaseController';
import 'Models/Common/HeaderBar';

export default class extends FFBaseController {
  ready(): void {
    super.ready();
  }
}
